import React, { useState, useEffect } from "react";
import "./service.css";
import Client from "../../common/axiosApi";
import { useNavigate } from "react-router-dom";

const Services = () => {
  const [service, setService] = useState();

  const navigate = useNavigate();

  console.log(service);

  const getService = async () => {
    try {
      const serviceResponse = await Client.get("/service/getAll");
      console.log(serviceResponse.data.getAll);

      if (serviceResponse.status === 200) {
        const services = serviceResponse.data.getAll;

        setService(services);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getService();
  }, []);

  const getEach = (id, service) => {
    console.log("geteach");
    navigate(`/${service}/${id}`);
  };

  return (
    <>
      <div className="container p-4">
        <h2
          style={{
            color: " #00436b",
            fontFamily: '"Oxanium", serif',
            textAlign: "center",
            marginBottom: "19px",
          }}
        >
          What We Do
        </h2>
        <div className="row">
          {service &&
            service.map((each, index) => {
              return (
                <div
                  className="col-md-4 mt-3 d-flex justify-content-center"
                  key={index}
                  onClick={() => getEach(each._id, each.service)}
                >
                  <div className="saas-service-card">
                    <img
                      src={each.image.url}
                      alt="saas-cloud"
                      className="saas-service-image"
                    />
                    <p className="saas-service-name">{each.service}</p>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default Services;
